
import {
  mdiViewDashboard,
  mdiAccountGroup,
  mdiCog,
  mdiPackageVariant,
  mdiShape,
  mdiPackage,
  mdiWeb,
  mdiViewGrid,
  mdiMessageTextOutline,
  mdiPostOutline,
  mdiFolderOutline,
  mdiTagMultipleOutline,
  mdiPalette,
  mdiApps,
  mdiBullhornOutline
} from '@mdi/js'

export default [
  {
    title: 'General',
    items: [
      {
        to: '/admin/dashboard',
        label: 'Dashboard',
        icon: mdiViewDashboard
      },
      {
        label: 'Pengumuman',
        to: '/admin/announcements',
        icon: mdiBullhornOutline
      }
    ]
  },
  
  {
    title: 'Management',
    items: [
      {
        label: 'Pengguna',
        icon: mdiAccountGroup,
        menu: [
          {
            to: '/admin/users-admin',
            label: 'Admin',
            icon: mdiAccountGroup
          },
          {
            to: '/admin/users',
            label: 'Customer',
            icon: mdiAccountGroup
          }
        ]
      },
      {
        label: 'Produk',
        icon: mdiPackageVariant,
        menu: [
          {
            to: '/admin/product-types',
            label: 'Jenis Produk',
            icon: mdiShape
          },
          {
            to: '/admin/products',
            label: 'Daftar Produk',
            icon: mdiPackage
          }
        ]
      },
      {
        label: 'Landing Page',
        icon: mdiWeb,
        menu: [
          {
            to: '/admin/landing-pages',
            label: 'Landing Pages',
            icon: mdiWeb
          },
          {
            to: '/admin/landing-pages-template',
            label: 'Landing Page Templates',
            icon: mdiViewGrid
          }
        ]
      },
      {
        label: 'Blog',
        icon: mdiPostOutline,
        menu: [
          {
            to: '/admin/blog/posts',
            label: 'Artikel',
            icon: mdiPostOutline
          },
          {
            to: '/admin/blog/categories',
            label: 'Kategori',
            icon: mdiFolderOutline
          },
          {
            to: '/admin/blog/tags',
            label: 'Tag',
            icon: mdiTagMultipleOutline
          }
        ]
      },
      {
        to: '/admin/support/messages',
        label: 'Pesan Support',
        icon: mdiMessageTextOutline,
        badgeKey: 'support'
      }
    ]
  },
   {
     title: 'Setting',
     items: [
       {
         label: 'Pengaturan',
         icon: mdiCog,
         menu: [
          //  {
          //    label: 'Profil Saya',
          //    to: '/admin/profile',
          //    icon: mdiAccount
          //  },
           {
             label: 'Tampilan',
             to: '/admin/settings/appearance',
             icon: mdiPalette
           },
           {
            label: 'General Setting',
            to: '/admin/settings/general',
            icon: mdiApps
          },
          //  {
          //    label: 'Aktivitas Log',
          //    to: '/admin/settings/activity',
          //    icon: mdiHistory
          //  },
         ]
       }
     ]
   },
]
